module.exports = __webpack_public_path__ + "img/Glow Engines.e228e6f5.jpg";